import { FSA } from '../constants';

export const FETCH = 'USERS_FETCH';
export const fetchAll = (): FSA => ({ type: FETCH });
